import { call, put } from "redux-saga/effects";
import { subscriptionConstants } from "../actions/constants/subscriptionConstants";
import { commonConstants } from "../actions/constants/commonConstants";
import { subscriptionService } from "../services/subscriptionService";

function* getSubscriptionPlan(action: any): any {
  try {
    const response = yield call(subscriptionService.getSubscriptionPlan, action.payload);
    
    if (response.success) {
      yield put({  type: subscriptionConstants.getSubscriptionPlanSuccess, payload: response.resultObject 
      });
    } else {
      yield put({  type: subscriptionConstants.getSubscriptionPlanFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.getSubscriptionPlanFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || "Failed to fetch subscription plan" });
  }
}

function* getAllPlans(): any {
  try {
    const response = yield call(subscriptionService.getAllPlans);
    
    if (response.success) {
      yield put({  type: subscriptionConstants.getAllPlansSuccess, payload: response.resultObject 
      });
    } else {
      yield put({  type: subscriptionConstants.getAllPlansFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.getAllPlansFailure, payload: error });
  }
}

function* createSubscription(action: any): any {
  try {
    const response = yield call(subscriptionService.createSubscription, action.payload);
    if (response.success) {
      yield put({ type: subscriptionConstants.createSubscriptionSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message || "Subscription created successfully" });
    } else {
      yield put({ type: subscriptionConstants.createSubscriptionFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.createSubscriptionFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || "Failed to create subscription" });
  }
}

function* getSubscriptionStatus(action: any): any {
  try {
    const response = yield call(subscriptionService.getSubscriptionStatus, action.payload);
    if (response.success) {
      yield put({ type: subscriptionConstants.getSubscriptionStatusSuccess, payload: response.resultObject });
    } else {
      yield put({ type: subscriptionConstants.getSubscriptionStatusFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.getSubscriptionStatusFailure, payload: error });
  }
}

function* getOrderStatus(action: any): any {
  try {
    const response = yield call(subscriptionService.getOrderStatus, action.payload);
    if (response.success) {
      yield put({ type: subscriptionConstants.getOrderStatusSuccess, payload: response.resultObject });
    } else {
      yield put({ type: subscriptionConstants.getOrderStatusFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.getOrderStatusFailure, payload: error });
  }
}

function* syncPlans(): any {
  try {
    const response = yield call(subscriptionService.syncPlans);
    if (response.success) {
      yield put({ type: subscriptionConstants.syncPlansSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message || "Plans synced successfully" });
    } else {
      yield put({ type: subscriptionConstants.syncPlansFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.syncPlansFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || "Failed to sync plans" });
  }
}

function* getUserSubscriptionStatus(): any {
  try {
    const response = yield call(subscriptionService.getUserSubscriptionStatus);
    if (response.success) {
      yield put({ type: subscriptionConstants.getUserSubscriptionStatusSuccess, payload: response.resultObject });
    } else {
      yield put({ type: subscriptionConstants.getUserSubscriptionStatusFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.getUserSubscriptionStatusFailure, payload: error });
  }
}

export const subscriptionSaga = {
  getSubscriptionPlan,
  createSubscription,
  getSubscriptionStatus,
  getOrderStatus,
  syncPlans,
  getAllPlans,
  getUserSubscriptionStatus,
};
